import Axios from "axios";//AJAX插件
import {Indicator, Toast} from 'mint-ui'

var CryptoJS = require("crypto-js");

export default {
  /**
   * 封装ajax的get请求
   * @param url
   * @param params
   * @param successFun
   * @param failFun
   * @param errorFun
   */
  getJson: function (url, params, successFun, failFun, errorFun) {
    
    var req = {
      url: url,
      method: 'get',
      params: params,
    };
    Indicator.open('加载中...');
    Axios(req).catch(
      function (err) {
        console.log(err);
        Indicator.close();
        if (err.response && err.response.data && err.response.data.result == 403) {
          window.onTokenExpireLoginAgain();
        }
        if (typeof errorFun == "function")
          errorFun(err.response.data);
        else {
          Toast({
            message: err.response && err.response.data.message ? err.response.data.message : "服务器通讯异常，请检查网络",
            position: 'top',
            duration: 2000
          });
        }
      }
    ).then(
      function (res) {
        Indicator.close();
        successFun(res ? res.data : res);
      }
    )
  },
  postJson: function (url, params, successFun, failFun, errorFun) {
    var req = {
      url: url,
      method: 'POST',
      data: params,
    };
    Indicator.open('加载中...');
    Axios(req).catch(
      function (err) {
        console.log(err);
        Indicator.close();
        if (err.result === 403) {
          window.onTokenExpireLoginAgain();
        }
        if (typeof errorFun == "function")
          errorFun(err.response.data);
        else {
          Toast({
            message: err.response && err.response.data.message ? err.response.data.message : "服务器通讯异常，请检查网络",
            position: 'top',
            duration: 2000
          });
        }
      }
    ).then(
      function (res) {
        Indicator.close();
        successFun(res.data);
      }
    );
  },
  postJsonOne: function (url, params, successFun, failFun, errorFun) {
    var req = {
      url: url,
      method: 'POST',
      data: params,
      headers: {token: sessionStorage.getItem('token')}
    };
    Indicator.open('加载中...');
    Axios(req).catch(
      function (err) {
        console.log(err);
        Indicator.close();
        if (err.result === 403) {
          window.onTokenExpireLoginAgain();
        }
        if (typeof errorFun == "function")
          errorFun(err.response.data);
        else {
          Toast({
            message: err.response && err.response.data.message ? err.response.data.message : "服务器通讯异常，请检查网络",
            position: 'top',
            duration: 2000
          });
        }
      }
    ).then(
      function (res) {
        Indicator.close();
        successFun(res.data);
      }
    );
  },
}

function sign(params, url) {
  var arrParams = [];
  if (params) {
    for (var key in params) {
      var str = key + "=" + params[key];
      arrParams.push(str);
    }
    arrParams.sort();
  } else {
    params = {};
  }
  var strParams = arrParams.length > 0 ? arrParams.join("&") : "";
  if (url) {
    var route = url.substring(url.indexOf("//") + 2);
    route = route.substring(route.indexOf("/"));
    if (strParams) {
      strParams = route + "?" + strParams;
    } else {
      strParams = route;
    }
  }
  var autograph = 'w83keis394jc55klua36';
  var paramsMD5 = CryptoJS.MD5(strParams + autograph).toString();
  params.sig = paramsMD5;
  return params;
}


// WEBPACK FOOTER //
// ./src/pub/utils/ajaxUtils.js